import { frontendURL } from '../../../helper/URLHelper';

const SupervisionIndex = () => import('./Index.vue');

// Only administrators can access supervision
const meta = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/supervision'),
    name: 'supervision_dashboard',
    component: SupervisionIndex,
    meta,
  },
];
